export *  from './snb-service-coterm.route';
export { SnbCoTermRoute as SnbCoTermRoute } from './snb-service-coterm.route';
export { TermsOfServiceRoute as TermsOfServiceRoute } from './snb-service-coterm.route';

export * from './snb-service-coterm.store';
export { default as SnbCoTermStoreModule } from './snb-service-coterm.store';
